export const colors = {
  dark: '#1e1e2f'
}

export const colors_stops = {
  forward: '#4caf50', // green
  backward: '#e91e63' // pink
}

export const colors_by_routes = {
  trolleybus: [
    '#0089B6',
    '#0000FF',
    '#8B00FF'
  ],
  tram: [
    '#9B2321',
    '#FF0000',
    '#FF5B8E'
  ],
  bus: [
    '#F4BF06',
    '#FFFF00',
    '#FF8000'
  ],
  mt: [] // хз
}

export class ClassColor {
  constructor(colors = colors_by_routes) {
    this.colors = colors
  }

  #default_color = `#999`
  #typeForKey(type) {
    switch (type) {
      case 1: return `tram`
      case 2: return `trolleybus`
      case 3: return `bus`
      case 4: return `mt`
      default: return null
    }
  }

  byRouteInMap(v, route_type, array) {
    let index = array.indexOf(v)
    let key = this.#typeForKey(route_type)
    let color = index !== -1 ? this.colors[key][index] : this.#default_color
    return key == null ? this.default_color : color
  }
}